import React from 'react'

export default class ReservaFuncionalText extends React.Component {
  vlookup(index, table) {
    for (var i = 0, l = table[0].length; i < l; i++) {
      if (index == table[0][i]) return table[1][i]
      if (i < l - 1) {
       if (index > table[0][i] && index < table[0][i + 1]) return table[1][i]
      }
      if (i == l) return table[1][l]
    }
  }

  render () {
    var presionArterialSistolica = (this.props.propiedades.data.medicalPAPA + this.props.propiedades.data.medicalPASA) / 2
    var presionArterialDiastolica = (this.props.propiedades.data.medicalPAPB + this.props.propiedades.data.medicalPASB) / 2
    var title = (this.props.propiedades.reservaFuncionalText === 'excelente') ? 'Su reserva funcional es muy buena: ' : (this.props.propiedades.reservaFuncionalText === 'regular') ? 'Su reserva ha disminuido más de lo esperado, te recomendamos: ' : (this.props.propiedades.reservaFuncionalText === 'mala') ? 'Su reserva es muy baja. Hay signos de fragilidad y su salud está en riesgo, necesitas cuanto antes: ' : ''

    var balancePerAge = [ [18, 40, 50, 60, 70, 80, 90, 100], [45, 42, 42, 32, 22, 10, 10, 10] ]
    var patientAge = this.props.propiedades.data.patientAge
    var balanceNeu = this.props.propiedades.data.medicalBalanceNeur
    var balanceExpected = this.vlookup(patientAge, balancePerAge)

    return (
      <div className='text-container'>
        <div className='someText' contentEditable='true'>
          { (this.props.propiedades.reservaFuncionalText === 'excelente')
            ? <div className='someText-body'>
                <div><strong className='blue'>{ title }</strong>Su estado de salud es muy bueno y su reserva funcional es alta. Esto indica que:</div>
                <ul>
                  <li>Ha manejado bien su peso, está físicamente activo y tiene balance emocional.</li>
                  <li>Su fuerza muscular y el control cerebral sobre su cuerpo son buenos.</li>
                  <li>Tiene fortaleza mental.</li>
                  <li>Su capacidad física está como la necesita.</li>
                  <li>Es una persona equilibrada en lo físico, mental, social y emocional</li>
                </ul>
              </div>
            : (this.props.propiedades.reservaFuncionalText === 'regular')
            ? <div className='someText-body'>
                <div><strong className='blue'>{ title }</strong></div>
                <ul>
                  { (this.props.propiedades.data.medicalBMIData >= 27) ? <li> Cuidar su peso. Éste puede ser mejor, así ayuda a sus arterias a estar más sanas.</li> : '' }
                  <li>Consumir menos sal en los alimentos.</li>
                  { (this.props.propiedades.data.medicalFrecuenciaC >= 80) ? <li>Fortalecer su corazón. Es mejor un corazón más fuerte con menos latidos por minuto.</li> : '' }
                  <li>Comer más frutas y vegetales.</li>
                  <li>Hacer pausas activas, estirarse, permanecer menos tiempo en un asiento.</li>
                  <li>Leer o escuchar algo que lo inspire.</li>
                  { (this.props.propiedades.data.medicalFuma === 'Si') ? <li>Evitar tóxicos, particularmente el cigarrillo.</li> : ''}
                  <li>Respirar mejor: inspire lenta y profundamente con frecuencia.</li>
                  { (this.props.propiedades.socClass === 'health-square-bad-printable left-square-printable') ? <li>Compartir con su familia y amigos</li> : ''}
                  { (this.props.propiedades.proyectos === 'No') ? <li>Empezar un nuevo proyecto.</li> : '' }
                  <li>Regalarse un rato en silencio, conéctese consigo mismo.</li>
                  <li>Vigilar y controlar su presión arterial, su ritmo cardiaco, su peso y sus niveles de azúcar en la sangre.</li>
                </ul>
              </div>
            : (this.props.propiedades.reservaFuncionalText === 'mala')
            ? <div className='someText-body'>
                <div><strong className='blue'>{ title }</strong></div>
                <ul>
                  { (this.props.propiedades.data.medicalBMIData > 29) ? <li>Reducir su peso.</li> : '' }
                  <li>Mejorar su capacidad cardiopulmonar. Inicie un programa de ejercicio. Pida una cita para hacer una evaluación previa.</li>
                  { (this.props.propiedades.data.medicalFrecuenciaC >= 80) ? <li>Mejorar su balance emocional, parece existir mucho estrés en su vida.</li> : '' }
                  { ((this.props.propiedades.balanceA < 7) || (this.props.propiedades.satif < 7)) ? <li>Ha perdido fortaleza muscular y equilibrio.</li> : '' }
                  { ((presionArterialSistolica > 140) || (presionArterialDiastolica > 90)) ? <li>Tiene presión arterial alta.</li> : '' }
                  { (balanceNeu < balanceExpected) ? <li>Ha perdido fortaleza muscular y equilibrio.</li> : '' }
                </ul>
              </div>
            : ''
          }
        </div>
      </div>
    )
  }
}

ReservaFuncionalText.propTypes = {
  propiedades: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDashboard/reservaText.js